// extracted by mini-css-extract-plugin
export default {"cancelTextStyle":"ProjectOwnerCancelRequest_cancelTextStyle_DGp0m","spinAround":"ProjectOwnerCancelRequest_spinAround_tZ_z7"};